import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import StyledTextarea from "../../CommonComponents/StyledTextarea/StyledTextarea";
import {useTheme} from "../../../contexts/theme";

export interface DefaultSocialFormState{
    title: string;
    description: string;
}

interface DefaultSocialFormProps {
    onFieldChange: (field: string, value: string | boolean) => void;
    defaultFormState: DefaultSocialFormState
}

const DefaultSocialForm: React.FC<DefaultSocialFormProps> = ({onFieldChange, defaultFormState}) => {
    const theme = useTheme()
    const inputTextStyle = {
        borderBottomColor:theme.palette.orange,
        marginBottom: theme.spacing.md,
        backgroundColor: 'none',
        color: theme.palette.white,
        borderColor: theme.palette.white,
        borderRadius: theme.border.width.hard
    }

    return (
        <Grid container marginTop={theme.spacing.md}>
            <Grid item lg={6} md={12} paddingRight={theme.spacing.md}>
                <Box display="flex" flexDirection={'column'}>
                    <TextinputField
                        value={defaultFormState.title}
                        name={"defaultTitle"}
                        placeholder={"Type post title"}
                        type={'text'}
                        variant={'outlined'}
                        onChange={(e) => onFieldChange('title', e.target.value)}
                        {...inputTextStyle}
                    />
                </Box>
            </Grid>
            <Grid item lg={6} md={12}>
                <StyledTextarea
                    placeholder={'Type post description'}
                    label={'Description'}
                    value={defaultFormState.description}
                    onChange={(e) => onFieldChange('description', e.target.value)}
                    width={'100%'}
                    height={'100%'}
                />
            </Grid>
        </Grid>
    )
}

export default DefaultSocialForm